import { render, staticRenderFns } from "./CookieLaw.vue?vue&type=template&id=2cba564a&scoped=true&"
import script from "./CookieLaw.vue?vue&type=script&lang=js&"
export * from "./CookieLaw.vue?vue&type=script&lang=js&"
import style0 from "./CookieLaw.vue?vue&type=style&index=0&id=2cba564a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cba564a",
  null
  
)

export default component.exports